import React from "react";

function SwipeBtn({ onChange, checked, name }: any) {
  const handleToggle = () => {
    onChange({ target: { name, value: !checked } });
  };
  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        name={name}
        checked={!checked}
        onChange={handleToggle}
        className="sr-only peer"
      />
      <div className="w-14 h-7 bg-primary peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary/30 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-primary"></div>
    </label>
  );
}

export default SwipeBtn;
